import { User } from "@drl/core/auth/models/user.model";

export class NonAherencePatientsCount {
  count: number;
  constructor(count: number) {
    this.count = count;
  }
}

export class AdherenceSummary {
  patientId?: number;
  contactNumber?: string;
  rxCompletionDays?: number;
  rxCompletionDate?: string;
  pastWeekNumber?: number;
  pastWeekDue?: boolean;
  currentWeekNumber?: number;
  currentWeekDue?: boolean;
  pastWeekAdherencePct?: number;
  currentWeekAdherencePct?: number;
  patientUserId?: any;
  presciptionName?: string;
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  externalId: string;
  counselDone: boolean;
  fullName:string;
  activityCompleted:boolean
  name: string;
  currentWeekAdhColor: string;
  pastWeekAdhColor: string;
  canChat?: boolean;
  constructor(data: Partial<AdherenceSummary>) {
    Object.assign(this, data);
  }
}

